import { HashRouter, NavLink, Outlet, Route, Routes } from "react-router-dom";
import { Icone, type NomeIcone } from "./ui/Icone";
import { ModuloHome } from "./screens/ModuloHome";
import { PainelProfissional } from "./screens/PainelProfissional";
// Pitada — terapia alimentar (módulo do app Degrau)
import { Hoje } from "./screens/Hoje";
import { Biblioteca } from "./screens/Biblioteca";
import { NovoAlimento } from "./screens/NovoAlimento";
import { DetalheAlimento } from "./screens/DetalheAlimento";
import { RegistrarOferta } from "./screens/RegistrarOferta";
import { ModoEscolha } from "./screens/ModoEscolha";
import { PrepararRefeicao } from "./screens/PrepararRefeicao";
import { Seguros } from "./screens/Seguros";
import { Relatorio } from "./screens/Relatorio";
import { Config } from "./screens/Config";
import { CadastroPaciente } from "./screens/CadastroPaciente";
// Compasso — musicoterapia
import { HojeMusica } from "./music/screens/HojeMusica";
import { RegistrarMomento } from "./music/screens/RegistrarMomento";
import { BibliotecaMusica } from "./music/screens/BibliotecaMusica";
import { NovaExperiencia } from "./music/screens/NovaExperiencia";
import { DetalheExperiencia } from "./music/screens/DetalheExperiencia";
import { KitRapido } from "./music/screens/KitRapido";
import { RelatorioMusica } from "./music/screens/RelatorioMusica";
import { ModoEscolhaMusical } from "./music/screens/ModoEscolhaMusical";
import { ConfigMusica } from "./music/screens/ConfigMusica";
// Elo — integração interdisciplinar
import { HojeElo } from "./elo/screens/HojeElo";
import { Equipe } from "./elo/screens/Equipe";
import { NovoProfissional } from "./elo/screens/NovoProfissional";
import { DetalheProfissional } from "./elo/screens/DetalheProfissional";
import { RegistrarSessao } from "./elo/screens/RegistrarSessao";
import { TimelineIntegrada } from "./elo/screens/TimelineIntegrada";
import { DetalheNota } from "./elo/screens/DetalheNota";
import { OrientacoesCasa } from "./elo/screens/OrientacoesCasa";
import { RelatorioElo } from "./elo/screens/RelatorioElo";
import { ConfigElo } from "./elo/screens/ConfigElo";
// Gingado — psicomotricidade
import { HojeCorpo } from "./body/screens/HojeCorpo";
import { RegistrarMomentoPsm } from "./body/screens/RegistrarMomentoPsm";
import { BibliotecaCorpo } from "./body/screens/BibliotecaCorpo";
import { NovaAtividade } from "./body/screens/NovaAtividade";
import { DetalheAtividade } from "./body/screens/DetalheAtividade";
import { KitCorpo } from "./body/screens/KitCorpo";
import { RelatorioCorpo } from "./body/screens/RelatorioCorpo";
import { ModoEscolhaCorporal } from "./body/screens/ModoEscolhaCorporal";
import { ConfigCorpo } from "./body/screens/ConfigCorpo";
// Agenda — gestão de clínica (camada transversal, opcional)
import { AgendaCalendario } from "./agenda/screens/AgendaCalendario";
import { NovoAgendamento } from "./agenda/screens/NovoAgendamento";
import { DetalheAgendamento } from "./agenda/screens/DetalheAgendamento";
import { ConfigAgenda } from "./agenda/screens/ConfigAgenda";
// Nuvem — modo profissional (camada aditiva). CARREGADA SOB DEMANDA (React.lazy):
// o app de família não baixa o PowerSync/wasm — só quem entra em /nuvem.
import { lazy, Suspense } from "react";
const CloudApp = lazy(() => import("./cloud/CloudApp"));

/**
 * HashRouter (não BrowserRouter): no app nativo (Capacitor) os assets são servidos
 * de um esquema local sem servidor de rotas — hash evita 404 em deep links.
 *
 * A raiz "/" é o seletor de módulos. Cada módulo (Pitada alimentar, Compasso musical)
 * tem sua própria navegação inferior e compartilha o mesmo paciente e o mesmo banco.
 */
export function App() {
  return (
    <HashRouter>
      <div className="app">
        <Routes>
          {/* Raiz: escolha do módulo */}
          <Route path="/" element={<ModuloHome />} />

          {/* Painel do profissional (Archetype E) — visão desktop, tela cheia */}
          <Route path="/painel" element={<PainelProfissional />} />

          {/* Telas em tela cheia (modo criança / preparo) — sem navegação competindo */}
          <Route path="/crianca" element={<ModoEscolha />} />
          <Route path="/refeicao" element={<PrepararRefeicao />} />
          <Route path="/compasso/crianca" element={<ModoEscolhaMusical />} />
          <Route path="/gingado/crianca" element={<ModoEscolhaCorporal />} />

          {/* Cadastro do paciente — compartilhado pelos módulos */}
          <Route path="/paciente" element={<CadastroPaciente />} />

          {/* ── Pitada (terapia alimentar) ── */}
          <Route element={<LayoutCuidador />}>
            <Route path="/degrau" element={<Hoje />} />
            <Route path="/biblioteca" element={<Biblioteca />} />
            <Route path="/biblioteca/novo" element={<NovoAlimento />} />
            <Route path="/alimento/:id" element={<DetalheAlimento />} />
            <Route path="/registrar" element={<RegistrarOferta />} />
            <Route path="/registrar/:alimentoId" element={<RegistrarOferta />} />
            <Route path="/seguros" element={<Seguros />} />
            <Route path="/relatorio" element={<Relatorio />} />
            <Route path="/config" element={<Config />} />
          </Route>

          {/* ── Compasso (musicoterapia) ── */}
          <Route element={<LayoutCompasso />}>
            <Route path="/compasso" element={<HojeMusica />} />
            <Route path="/compasso/biblioteca" element={<BibliotecaMusica />} />
            <Route path="/compasso/biblioteca/nova" element={<NovaExperiencia />} />
            <Route path="/compasso/experiencia/:id" element={<DetalheExperiencia />} />
            <Route path="/compasso/registrar" element={<RegistrarMomento />} />
            <Route path="/compasso/registrar/:experienciaId" element={<RegistrarMomento />} />
            <Route path="/compasso/kit" element={<KitRapido />} />
            <Route path="/compasso/relatorio" element={<RelatorioMusica />} />
            <Route path="/compasso/config" element={<ConfigMusica />} />
          </Route>

          {/* ── Elo (integração interdisciplinar) ── */}
          <Route element={<LayoutElo />}>
            <Route path="/elo" element={<HojeElo />} />
            <Route path="/elo/equipe" element={<Equipe />} />
            <Route path="/elo/equipe/novo" element={<NovoProfissional />} />
            <Route path="/elo/profissional/:id" element={<DetalheProfissional />} />
            <Route path="/elo/registrar" element={<RegistrarSessao />} />
            <Route path="/elo/registrar/:profissionalId" element={<RegistrarSessao />} />
            <Route path="/elo/timeline" element={<TimelineIntegrada />} />
            <Route path="/elo/casa" element={<OrientacoesCasa />} />
            <Route path="/elo/nota/:id" element={<DetalheNota />} />
            <Route path="/elo/relatorio" element={<RelatorioElo />} />
            <Route path="/elo/config" element={<ConfigElo />} />
          </Route>

          {/* ── Gingado (psicomotricidade) ── */}
          <Route element={<LayoutGingado />}>
            <Route path="/gingado" element={<HojeCorpo />} />
            <Route path="/gingado/biblioteca" element={<BibliotecaCorpo />} />
            <Route path="/gingado/biblioteca/nova" element={<NovaAtividade />} />
            <Route path="/gingado/atividade/:id" element={<DetalheAtividade />} />
            <Route path="/gingado/registrar" element={<RegistrarMomentoPsm />} />
            <Route path="/gingado/registrar/:atividadeId" element={<RegistrarMomentoPsm />} />
            <Route path="/gingado/kit" element={<KitCorpo />} />
            <Route path="/gingado/relatorio" element={<RelatorioCorpo />} />
            <Route path="/gingado/config" element={<ConfigCorpo />} />
          </Route>

          {/* ── Agenda (gestão de clínica) — camada opcional, fora dos módulos ── */}
          {/* Config fica fora do layout (é a porta de ativação, acessível inativa) */}
          <Route path="/agenda/config" element={<ConfigAgenda />} />
          <Route element={<LayoutAgenda />}>
            <Route path="/agenda" element={<AgendaCalendario />} />
            <Route path="/agenda/novo" element={<NovoAgendamento />} />
            <Route path="/agenda/novo/:id" element={<NovoAgendamento />} />
            <Route path="/agenda/:id" element={<DetalheAgendamento />} />
          </Route>

          {/* ── Nuvem (modo profissional) — lazy: só baixa ao entrar em /nuvem ── */}
          <Route
            path="/nuvem/*"
            element={
              <Suspense fallback={<div style={{ minHeight: "100dvh", display: "grid", placeItems: "center", color: "#6e665a" }}>Carregando…</div>}>
                <CloudApp />
              </Suspense>
            }
          />
        </Routes>
      </div>
    </HashRouter>
  );
}

function LayoutCuidador() {
  return (
    <>
      <Outlet />
      <nav className="nav" aria-label="navegação do Pitada">
        <Tab to="/" ico="grid" rotulo="módulos" fim />
        <Tab to="/degrau" ico="home" rotulo="hoje" fim />
        <Tab to="/biblioteca" ico="library" rotulo="biblioteca" />
        <Tab to="/registrar" ico="register" rotulo="registrar" />
        <Tab to="/seguros" ico="seguros" rotulo="seguros" />
        <Tab to="/relatorio" ico="doc" rotulo="relatório" />
      </nav>
    </>
  );
}

function LayoutCompasso() {
  return (
    <>
      <Outlet />
      <nav className="nav" aria-label="navegação do Compasso">
        <Tab to="/" ico="grid" rotulo="módulos" fim />
        <Tab to="/compasso" ico="home" rotulo="hoje" fim />
        <Tab to="/compasso/biblioteca" ico="library" rotulo="biblioteca" />
        <Tab to="/compasso/registrar" ico="register" rotulo="registrar" />
        <Tab to="/compasso/kit" ico="kit" rotulo="kit" />
        <Tab to="/compasso/relatorio" ico="doc" rotulo="relatório" />
      </nav>
    </>
  );
}

function LayoutElo() {
  return (
    <>
      <Outlet />
      <nav className="nav" aria-label="navegação do Elo">
        <Tab to="/" ico="grid" rotulo="módulos" fim />
        <Tab to="/elo" ico="home" rotulo="hoje" fim />
        <Tab to="/elo/registrar" ico="register" rotulo="registrar" />
        <Tab to="/elo/timeline" ico="timeline" rotulo="timeline" />
        <Tab to="/elo/relatorio" ico="doc" rotulo="relatório" />
      </nav>
    </>
  );
}

function LayoutGingado() {
  return (
    <>
      <Outlet />
      <nav className="nav" aria-label="navegação do Gingado">
        <Tab to="/" ico="grid" rotulo="módulos" fim />
        <Tab to="/gingado" ico="home" rotulo="hoje" fim />
        <Tab to="/gingado/biblioteca" ico="library" rotulo="biblioteca" />
        <Tab to="/gingado/registrar" ico="register" rotulo="registrar" />
        <Tab to="/gingado/kit" ico="kit" rotulo="kit" />
        <Tab to="/gingado/relatorio" ico="doc" rotulo="relatório" />
      </nav>
    </>
  );
}

function LayoutAgenda() {
  return (
    <>
      <Outlet />
      <nav className="nav" aria-label="navegação da Agenda">
        <Tab to="/" ico="grid" rotulo="módulos" fim />
        <Tab to="/agenda" ico="calendar" rotulo="calendário" fim />
        <Tab to="/agenda/novo" ico="plus" rotulo="nova" />
        <Tab to="/agenda/config" ico="config" rotulo="config" />
      </nav>
    </>
  );
}

function Tab({
  to,
  ico,
  rotulo,
  fim,
}: {
  to: string;
  ico: NomeIcone;
  rotulo: string;
  fim?: boolean;
}) {
  return (
    <NavLink to={to} end={fim} className={({ isActive }) => (isActive ? "ativo" : "")}>
      <span className="ico" aria-hidden>
        <Icone name={ico} size={24} />
      </span>
      {rotulo}
    </NavLink>
  );
}
